import classnames from 'classnames';
import { bemHelper } from '@dbk/ui-react-utils';

import styles from './popover.css';

const bem = bemHelper(styles, 'popper-inline');

export default (orientation, displayBlock, className) =>
  classnames('popper-inline', className, bem(null, orientation), {
    [bem(null, 'block')]: displayBlock,
  });
